import React from "react"
import SEO from "../components/seo"
import { Link } from "gatsby"
import Layout from "../app/layout"

import { Button } from "antd"

import Container from "../components/Container";

const NotFound = () => (
  <Layout>
      <SEO title="404 Not Found" />
      
      <Container>
          <div className="section text-center" style={{ display: 'flex', justifyContent: 'center', height: '80vh', flexDirection: 'column' }}>
              <h1 style={{ marginBottom: 0 }}>404</h1>
              <h4>Halaman tidak ditemukan</h4>
              <Button size="large" type="link"><Link to="/">Kembali ke Beranda</Link></Button>
          </div>
      </Container>
  </Layout>
)

export default NotFound
